import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';
import { BixAlertComponent } from './bix-alert.component';

@Injectable({
  providedIn: 'root'
})
export class BixAlertService {

  constructor(private _snackBar: MatSnackBar, private _dialog: MatDialog) {}

  success(title: string, desc:string, duration: number = 3000) {
    this._snackBar.openFromComponent(BixAlertComponent, {
      duration: duration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      panelClass: 'bix-alert-container',
      data: {
        title: title,
        description: desc,
        type: 0
      }
    });
  }
  error(title: string, desc:string, duration: number = 3000) {
    this._snackBar.openFromComponent(BixAlertComponent, {
      duration: duration,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      panelClass: 'bix-alert-container',
      data: {
        title: title,
        description: desc,
        type: 1
      }
    });
  }

  showApiSuccess(response, type="other", btnText="OK", disableClose=false) {
    let message = response['message'][0];
    return this._dialog.open(SuccessPopupComponent, {
      width: '390px',
      data: {
        Create_msg: message,
        btnText: btnText,
        btnClose: 'Close',
        type: type
      },
      disableClose:disableClose,
      panelClass: 'success-popup-wrapper'
    });
  }

  handleApiError({error}) {
    // console.log(error,'saas');
    if(error instanceof Object ){
      if(error.hasOwnProperty('errors')) {
        let errors = error.errors;
        if(errors.hasOwnProperty('message')) {
          let message = errors.message;
          if(message instanceof Array) {
            this.error("Oops!", message[0], 3000);
          }
        }else {
          let error = errors[Object.keys(errors)[0]];
          if(error instanceof Array){
            this.error("Oops!", error[0], 3000);
          }
          
        }
      }else if(error.hasOwnProperty('message')){
        let message = error['message'];
        if(message instanceof Array) {
          this.error("Oops!", message[0], 3000);
        }else{
          this.error("Oops!", message, 3000);
        }
      }
    }
  }
}
